import { makeStyles } from '@material-ui/core';
import codearc from '../../assets/codearc.png';

const useStyles = makeStyles({
  logo: {
    width: 180,
    height: 'auto',
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();

  return <img className={classes.logo} src={codearc} alt="Codearc" />;
};
